export default __webpack_public_path__ + "static/media/ellipse-top-right.9b920e8f.svg";